module.exports = __webpack_public_path__ + "static/bird-zoom-6792ebbe1c90bf4ae0cd3a67d5b30185.jpg";